<template>
    <CompassTableRow class="automation-listing-table-loading-state__row">
        <template v-for="column in columns">
            <CompassTableBodyCell
                v-if="column.code === 'name'"
                :key="column.code"
                :maxWidth="column.maxWidth"
            >
                <CompassSkeleton />
            </CompassTableBodyCell>
            <CompassTableBodyCell
                v-if="column.code === 'date'"
                :key="column.code"
                :fixed="column.fixed"
                :maxWidth="column.maxWidth"
                :minWidth="column.minWidth"
            >
                <CompassSkeleton />
            </CompassTableBodyCell>
            <CompassTableBodyCell
                v-if="column.code === 'status'"
                :key="column.code"
                :alignContent="column.alignContent"
                :fixed="column.fixed"
                :maxWidth="column.maxWidth"
                :minWidth="column.minWidth"
            >
                <CompassSkeleton variant="square" />
            </CompassTableBodyCell>
            <CompassTableBodyCell
                v-if="column.code === 'actions'"
                :key="column.code"
                :fixed="column.fixed"
                :maxWidth="column.maxWidth"
                :minWidth="column.minWidth"
            >
                <CompassSkeleton variant="square" />
            </CompassTableBodyCell>
        </template>
    </CompassTableRow>
</template>

<script>
export default {
    props: {
        columns: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-listing-table-loading-state__row {
    &::v-deep {
        .compass-table__cell-container,
        .compass-skeleton {
            width: 100%;
        }
    }
}
</style>
